export default "__VITE_ASSET__AeZ2osfK__"